export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_JP = 'MM/DD/YYYY';
export const DATE_FORMAT_JP_2 = 'YYYY/MM/DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_FORMAT_WITH_HOURS_MINUTES = 'HH:mm';
export const MONTH_YEAR_FORMAT = 'YYYY-MM';
export const YEAR_MONTH_FORMAT = 'MM/YYYY';
export const MONTH_YEAR_FORMAT_JP = 'YYYY/MM';
export const YEAR_MONTH_DATE_FORMAT_JP = 'YYYY/MM/DD';
export const TIME_FORMAT_MINUS = 'HH:mm';
export const TIME_FORMAT_JP = 'YYYY/MM/DD HH:mm';

export enum CommonStatus {
  APPROVED = 1,
  PENDING = 0,
  REFUSED = -1,
}
